import { useState } from 'react';
import { Col, Drawer, Form, Input, message, Row } from 'antd';
import { drawerWidth, formItemLayout } from '../../../utils/constants';
import { DrawerFormButtons } from '../../../components/common/drawersFormButtons';
import UsersServices from '../../../services/usersServices';
import { useTranslation } from 'react-i18next';
import { CreateRolePayload } from './roles.types';

const NewRole = ({ open, onClose, getRoles }: { open: boolean, onClose: () => void, getRoles: () => void }) => {
    const { t } = useTranslation();
    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);

    const saveData = async (values: CreateRolePayload) => {
        setLoadingButton(true);
        try {
            const respData = await UsersServices.createRole(values);
            if (respData.success) {
                message.success(t('messages.success'));
                getRoles();
                onClose();
            }
            else {
                message.error(t('messages.errorAccured'));
            }

        } catch (error) {
            message.error(t('messages.errorAccured'));
        }
        finally {
            setLoadingButton(false);
        }
    }

    return (
        <Drawer
            title={t('roles.addNewRole')}
            width={drawerWidth}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <DrawerFormButtons disabled={!fieldsChanged} close={onClose} loadingButton={loadingButton} formId={"newRole"} />
            }
        >
            <Form
                id="newRole"
                layout="vertical"
                {...formItemLayout}
                onFinish={(values) => saveData(values)}
                onValuesChange={() => setFieldsChanged(true)}
            >
                <Row gutter={16}>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <Form.Item
                            label={t('roles.name')}
                            name="name"
                            rules={[{ required: true, message: t('messages.requiredField') }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <Form.Item
                            label={t('roles.description')}
                            name="description"
                            rules={[{ required: true, message: t('messages.requiredField') }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
}
export default NewRole;